package com.pincer.core.model.tree

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
data class Candidate
(
    // We use short form field names here as this is the biggest part of the
    // json signal so we can save alot on bandwidth. Maybe a cleverer way to
    // do the same thing with @SerialName, but this is KISS. Also, we get to
    // keep @JsName in the readable versions below.
    var st : String?,
    var du : Int?,
    var sc : Float?,
    var pt : String?,
    var un : String?,
)

{

    @JsName("start")          fun start() = st
    @JsName("duration")       fun duration() = du
    @JsName("score")          fun score() = sc
    @JsName("participantIds") fun participants() = pt
    @JsName("undecidedIds")   fun undecided() = un

    // Or perhaps that idea where they get grouped in collections by date and duration
    fun id() = "S" + st + "D" + du + "P" + (pt+un).hashCode()

    fun duplicate(): Candidate = Candidate(
        st = st,
        du = du,
        sc = sc,
        pt = pt,
        un = un,
    )

    fun attendance(principalId: String): Attendance {
        if (pt == null || un == null) return Attendance.UNKNOWN
        if (",$un,".contains(principalId)) return Attendance.UNKNOWN
        if (",$pt,".contains(principalId)) return Attendance.ATTENDING
        return Attendance.NOT_ATTENDING
    }

    fun getLocalisationKey(zone: String, locale: String) = "${st}_${zone}_${locale}"

    fun participants(pincer: Pincer): Set<Participant> = participantsForString(pt, pincer)

    fun undecided(pincer: Pincer): Set<Participant> = participantsForString(un, pincer)

    private fun participantsForString(ids: String?, pincer: Pincer): Set<Participant> {
        val build = mutableSetOf<Participant>()
        if (ids == null) return build
        for (id in (""+ids).split(",")) {
            if (pincer.participants[id] != null) build.add(pincer.participants[id]!!)
        }
        return build
    }

    //fun end() = start()!! + duration()!! * 60

}

public enum class Attendance() { ATTENDING, UNKNOWN, NOT_ATTENDING }
